export enum Privacy {
  PUBLIC= 'PUBLIC',
  TRACKED = 'TRACKED',
  PROTECTED = 'PROTECTED',
  CRITICAL = 'CRITICAL'
}
